import React from "react";
import {Image} from "react-bootstrap";

export const WifiWeak = -90;
export const WifiOkay = -85;
export const WifiGreat = -75;
export const WifiExcellent = -55;

function WiFiSymbol ({ wifiStrength }) {

    const getSymbol = () => {
        if (wifiStrength === 0 || wifiStrength === null) {
            return (
                <Image src={require('../../img/wifi-weak.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
            );
        } else if (wifiStrength >= WifiExcellent) {
            return (
                <Image src={require('../../img/wifi-excellent.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
            );
        } else if (wifiStrength >= WifiGreat) {
            return (
                <Image src={require('../../img/wifi-great.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
            );
        } else if (wifiStrength >= WifiOkay) {
            return (
                <Image src={require('../../img/wifi-okay.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
            );
        } else if (wifiStrength >= WifiWeak) {
            return (
                <Image src={require('../../img/wifi-weak.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
            );
        } else {
            return (
                <Image src={require('../../img/wifi-weak.png')} style={{height: 2 + "em", width: 2.5 + "em"}}/>
            );
        }
    };

    return (
        getSymbol()
    );
}

export default WiFiSymbol;